// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adm-check-list-item-extra {\n  font-size: var(--adm-font-size-10);\n  line-height: 1;\n  color: var(--adm-color-primary);\n}\n.adm-check-list-item-readonly {\n  cursor: unset;\n}\n", ""]);
// Exports
module.exports = exports;
